/** @file Removes the mirror vertex maps of a mesh and of its -L/-R counterpart. */
import type { Draft } from 'immer';
import type { Doc, MeshAtt } from '@pose2d/format/types';
import { mirrorCounterpart } from './mirrorCounterpart';

/** Deletes `mirrorVertexMap` on `mesh` and on its counterpart (Reflect.deleteProperty, never a setter); true when either had one. */
export function dropMirrorMaps(draft: Draft<Doc>, mesh: MeshAtt): boolean {
  const holders = [mesh, mirrorCounterpart(draft, mesh.name)?.mesh].filter((m): m is MeshAtt => m?.mirrorVertexMap !== undefined);
  for (const m of holders) Reflect.deleteProperty(m, 'mirrorVertexMap');
  return holders.length > 0;
}
